import { render, staticRenderFns } from "./PreventiveMaintenance.vue?vue&type=template&id=24891d87"
import script from "./PreventiveMaintenance.js?vue&type=script&lang=js&external"
export * from "./PreventiveMaintenance.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports